// Tools
import { useEffect, useState } from "react";
import MaterialTable, {
    Column,
    EditComponentProps,
} from "@material-table/core";
// eFileMadeEasy
import { EmailReciptService } from "../../../../services/SubmissionService";
import * as APIModels from "../../../../models";

export default function EmailReceipt({
    submission,
}: {
    submission: APIModels.Submission;
}) {
    const never = "never" as const;
    const ID = submission?.id;
    const [updatedReceipts, setUpdatedReceipts] = useState(
        [] as APIModels.EmailReceipt[]
    );
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        EmailReciptService.getList({
            submissionId: ID ?? "",
        }).then(
            (resp) => {
                if (resp?.successful === true && resp?.data) {
                    setUpdatedReceipts(resp?.data);
                } else {
                    setErrorMessage(resp?.errorMessage ?? "");
                }
            },
            (error) => {
                setErrorMessage(error);
            }
        );
        if (errorMessage !== "") {
            console.log(errorMessage);
        }
        setErrorMessage("");
    }, [ID]);

    return (
        <div className="card text-center">
            <div>
                <button
                    className="btn small btn-primary"
                    style={{ float: "right" }}
                    onClick={() => {
                        EmailReciptService.sendReceipts({
                            id: submission?.id ?? "",
                        }).then(
                            (resp) => {
                                if (
                                    resp?.successful === true &&
                                    (resp?.data?.length ?? 0) > 0
                                ) {
                                    console.log(resp?.successful);
                                } else {
                                    setErrorMessage(resp?.errorMessage ?? "");
                                }
                            },
                            (error) => {
                                setErrorMessage(error);
                            }
                        );
                        if (errorMessage !== "") {
                            console.log(errorMessage);
                        }
                        setErrorMessage("");
                    }}
                >
                    Send Service Email
                </button>
            </div>
            <div className="card-body">
                <div style={{ maxWidth: "100%", zIndex: -1 }}>
                    <MaterialTable
                        data={updatedReceipts}
                        title={"Email Receipts"}
                        columns={[
                            {
                                title: "To",
                                field: "to",
                                editable: never,
                            },
                            {
                                title: "BCC",
                                field: "bcc",
                                editable: never,
                            },
                            {
                                title: "Date Sent",
                                field: "sent",
                                editable: never,
                            },
                        ]}
                    />
                </div>
            </div>
        </div>
    );
}
